import { render, staticRenderFns } from "./UcInvoiceTotals.yaml?vue&type=template&id=24cdef5d&component"
import script from "./UcInvoiceTotals.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceTotals.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports